import React, { useRef, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import TooltipAction from '../TooltipAction/TooltipAction';
import './TalentTag.css';

export const TalentTag = ({ text, color, onRemove, onClick, showText = true }) => {
  const textRef = useRef(null);
  const tagRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [tooltip, setTooltip] = useState({ visible: false, message: '', position: null });

  useEffect(() => {
    if (textRef.current && showText) {
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [text, showText]);

  const handleRemove = (e) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove();
    }
  };

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  const handleMouseEnter = () => {
    if (isTruncated && showText && tagRef.current) {
      const rect = tagRef.current.getBoundingClientRect();
      setTooltip({
        visible: true,
        message: text,
        position: {
          top: rect.top + rect.height / 2,
          left: rect.left + rect.width + 8,
        },
      });
    }
  };

  const handleMouseLeave = () => {
    setTooltip({ visible: false, message: '', position: null });
  };

  const backgroundColor = color || '#D8F6F5';
  const hasRemove = !!onRemove;
  const isClickable = !!onClick;
  const isMinimized = !showText;

  return (
    <div className="talentTagWrapper">
      <div
        ref={tagRef}
        className={`talentTag ${isClickable ? 'talentTagClickable' : ''} ${isMinimized ? 'talentTagMinimized' : ''}`}
        style={{ backgroundColor }}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {showText && <div className="text" ref={textRef}>{text}</div>}
        {hasRemove && showText && (
          <button
            className="talentTagRemove"
            onClick={handleRemove}
            aria-label="Remover tag"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 3L3 9M3 3L9 9"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </div>

      {tooltip.visible && tooltip.position && ReactDOM.createPortal(
        <TooltipAction
          message={tooltip.message}
          visible={tooltip.visible}
          style={{
            position: 'fixed',
            top: `${tooltip.position.top}px`,
            left: `${tooltip.position.left}px`,
            transform: 'translateY(-50%)',
            zIndex: 999999,
          }}
        />,
        document.body
      )}
    </div>
  );
};

export default TalentTag;

